module.exports = __webpack_public_path__ + "img/07.c957ee89.jpg";